export type Navigate = (route: string) => void;
export type RouteHandler = (
  container: HTMLElement,
  navigate: Navigate,
  query: URLSearchParams,
) => (() => void) | void;

function currentHash(): string {
  return location.hash.replace(/^#\/?/, '');
}

function currentRoutePath(fallback: string): string {
  const [path] = currentHash().split('?');
  return path || fallback;
}

function currentQuery(): URLSearchParams {
  const [, query = ''] = currentHash().split('?');
  return new URLSearchParams(query);
}

export function createRouter(
  container: HTMLElement,
  routes: Record<string, RouteHandler>,
  fallback: string,
): { navigate: Navigate } {
  let destroyCurrent: (() => void) | void;

  const navigate: Navigate = (route) => {
    if (currentRoutePath(fallback) === route) {
      resolve();
    } else {
      location.hash = `/${route}`;
    }
  };

  function resolve() {
    const route = currentRoutePath(fallback);
    const handler = routes[route] ?? routes[fallback];
    if (destroyCurrent) destroyCurrent();
    container.innerHTML = '';
    destroyCurrent = handler(container, navigate, currentQuery());
  }

  window.addEventListener('hashchange', resolve);
  resolve();

  return { navigate };
}
